import { render, staticRenderFns } from "./MedicalRecordsAdd.vue?vue&type=template&id=01a89b30&scoped=true&"
import script from "./MedicalRecordsAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordsAdd.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordsAdd.vue?vue&type=style&index=0&id=01a89b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a89b30",
  null
  
)

export default component.exports